import React, { FC, useEffect, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { addressRegex, emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import {
  onAddLeavePolicy,
  onAddLeaveRequest,
  onAddLeaveType,
} from "../../../services/leave";
import { SettingItem } from "../../orgSettings/SettingsItem";
import Switch from "react-switch";
import { contractTypes } from "../../../constant/data";
import useLeaveHook from "../../../hooks/useLeaveHook";
import Tooltip from "../../generic/Tooltip";
import Datepicker from "../../generic/Datepicker";
import DatePicker from "react-datepicker";
import { MdDateRange } from "react-icons/md";
import useCalendarHook from "../../../hooks/useCalendarHook";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const leavtypehook = usePickerhook();
  const startdatepick = usePickerhook();
  const enddatepick = usePickerhook();
  const { setLoading } = useStateSetter();
  const { AddEmployee } = useEmployeeHook();
  const watchedFields = watch(["reason"]);
  const [duration, setduration] = useState(0);
  const [error, seterror] = useState("");
  const { weekends } = useCalendarHook();
  const [condition, setcondition] = useState(false);
  const [selectedLeavePolicy, setselectedLeavePolicy] = useState<any>({});
  const { SelectedOrg, selectedEmployee, config } = useStateGetter();
  const { OrgLeaveTypes, OrgLeavePolicies } = useLeaveHook();
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      condition &&
      leavtypehook.pickedRole &&
      selectedLeavePolicy?.accuralLimit
  );

  useEffect(() => {
    setselectedLeavePolicy(
      OrgLeavePolicies.filter(
        (lj: any) => lj.leaveType.id == leavtypehook.pickedRole.code
      )[0]
    );
  }, [leavtypehook.pickedRole]);

  useEffect(() => {
    if (duration < 0) {
      setcondition(false);

      seterror("Invalid Start date/End date");
    } else {
      setcondition(true);
      seterror("");
    }
  }, [duration]);

  useEffect(() => {
    console.log(selectedLeavePolicy);
    if (duration > parseInt(selectedLeavePolicy?.accuralLimit)) {
      setcondition(false);
      seterror("Duration Exceed Accural limit");
    } else {
      setcondition(true);
      seterror("");
    }
  }, [selectedLeavePolicy, duration]);

  const onSubmit = async (data: any) => {
    console.log(data);

    var postdata = {
      employeeID: selectedEmployee.id, // Required, example employee ID
      leaveTypeID: leavtypehook.pickedRole.code, // Required, example leave type ID
      startDate: startdatepick.pickedRole.name, // Required, example start date
      endDate: enddatepick.pickedRole.name, // Required, example end date
      reason: data.reason, // Optional, you can set null or leave empty
      organizationID: SelectedOrg.id, // Required, example organization ID
    };

    setLoading(true);
    try {
      var res = await onAddLeaveRequest(postdata, config);
      toast(res.message);
    } catch (e: any) {
      console.log(e);
      toast.error(e);
    } finally {
      setLoading(false);
    }
    props.show(false);
    setLoading(false);
    props.refresh();
  };

  function getduration() {
    var date1 = new Date(startdatepick.pickedRole.code);
    var date2 = new Date(enddatepick.pickedRole.code);

    const timeDifference = date2.getTime() - date1.getTime(); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to day
    return Math.round(daysDifference);
  }

  useEffect(() => {
    if (startdatepick.pickedRole && enddatepick.pickedRole) {
      setduration(getduration());
    }
  }, [startdatepick, enddatepick]);

  useEffect(() => {
    if (duration < 0) {
      seterror("End date cannot be earlier than start date");
    } else if (duration == 0) {
      seterror("Invalid duration");
    }
  }, [duration]);
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white max-h-[80vh] overflow-y-scroll w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm my-4">Leave Request</p>
          <div className="">
            <ListPicker
              fullwidth
              hook={leavtypehook}
              title="leave type"
              list={OrgLeaveTypes.map((item: any) => {
                return { name: item.leaveName, code: item.id };
              })}
            />

            <div className=" flex gap-4 w-full">
              <Datepicker
                defaultvalue={{
                  code: new Date(),
                  name: new Date().toDateString(),
                }}
                hook={startdatepick}
                title="Start date"
              />

              <Datepicker
                defaultvalue={{
                  code: new Date(),
                  name: new Date().toDateString(),
                }}
                hook={enddatepick}
                title="End date"
              />

              <div className="my-4 max-w-[150px] cursor-pointer">
                <p className="text-xs mb-2 flex  flex-col items-center">
                  Duration   </p>
                <div className=" p-2  flex text-sm bg-gray-100 w-full  rounded-[8px] items-center">
                  <p>{Math.trunc(duration - (duration / 7) * weekends.length)}</p> <span className="text-[10px]">(Work days)</span>
                </div>
              </div>
            </div>

            <InputField
              name="reason"
              title="Reason"
              placeholder={"Reason for leave"}
              control={control}
              isTextArea
              rules={{
                required: "Reason is required",
                pattern: {
                  value: textReg,
                  message: "Invalid reason",
                },
              }}
            />
          </div>

          <p className="w-full text-xs text-red-600 my-1 flex justify-center items-center">
            {error}
          </p>
          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              text="Submit request"
              disabled={!areFieldsFilled}
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
